/**
 * Biznes qoidalarining boshlang'ich (default) qiymatlari — `docs/05-backend-schema.md`
 * dagi `Setting` jadvali seedidan olingan. Bularning haqiqiy manbasi baza (`Setting`
 * jadvali); shu konstantalar faqat seed va zaxira (fallback) qiymatlar sifatida ishlatiladi.
 */

/** 1000 prosmotr uchun so'm (standart stavka). */
export const DEFAULT_RATE_PER_1000 = 5000

/**
 * Standart stavka bosqichlari (zinapoyali stavka). Boshlang'ich holat — bitta bosqich,
 * ya'ni AYNAN eski tekis stavka (`DEFAULT_RATE_PER_1000`). Oxirgi bosqich har doim "qolgan
 * barchasi" (eni e'tiborsiz), shuning uchun bitta bosqich = butun prosmotrga bir xil stavka.
 * `RateTier` tipi `api.ts`da (`import type` orqali ishlatiladi — runtime tsikl yo'q).
 */
export const DEFAULT_RATE_TIERS: readonly { views: number; ratePer1000: number }[] = [
  { views: 0, ratePer1000: DEFAULT_RATE_PER_1000 },
]

/** Tekshiruvgacha (postedAt dan) o'tadigan kunlar soni — shu kunda hisob yakunlanadi. */
export const DEFAULT_FIRST_CHECK_DAYS = 15

/** Bloger o'zi to'lov so'ray oladigan minimal balans (so'mda). */
export const DEFAULT_AUTO_PAYOUT_THRESHOLD = 200000

/** Har oyning nechanchi sanasida rejalashtirilgan to'lov yuborilishi. */
export const DEFAULT_SCHEDULED_PAYOUT_DAY = 5

/** Ariza yaratilishi uchun minimal obunachilar soni. */
export const DEFAULT_MIN_FOLLOWERS = 500

/** Rad etilgandan keyin qayta ariza berish uchun kutish muddati (kun). */
export const DEFAULT_REAPPLY_AFTER_DAYS = 30

/** Havola yuborilishini kutish muddati (kun) — shundan keyin `NO_LINK` bilan rad etiladi. */
export const DEFAULT_LINK_WAIT_DAYS = 7

/** Havola tekshirilishi (linkVerified) uchun kutilgan SLA (soat). */
export const LINK_VERIFY_SLA_HOURS = 48

/** Loyihaning yagona vaqt zonasi — barcha sanalar shu bo'yicha ko'rsatiladi. */
export const TIMEZONE = 'Asia/Tashkent'

/** `Setting` jadvalidagi qatorlarning kalitlari. */
export const SETTING_KEYS = {
  RATE_PER_1000: 'rate_per_1000',
  RATE_TIERS: 'rate_tiers',
  FIRST_CHECK_DAYS: 'first_check_days',
  AUTO_PAYOUT_THRESHOLD: 'auto_payout_threshold',
  SCHEDULED_PAYOUT_DAY: 'scheduled_payout_day',
  MIN_FOLLOWERS: 'min_followers',
  REAPPLY_AFTER_DAYS: 'reapply_after_days',
  LINK_WAIT_DAYS: 'link_wait_days',
  VIEWS_PROVIDER: 'views_provider',
} as const
export type SettingKey = (typeof SETTING_KEYS)[keyof typeof SETTING_KEYS]
